module.exports = __webpack_public_path__ + "c6902f0f4ca585677930006e968538c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/rs6/clubhouse1.png
// module id = 1082
// module chunks = 0